import * as yup from 'yup';
import { ICheckboxWithText } from '@dokucoach/common-types';

export const ResidentAdviceConsultationSchema = yup.object({
  initialInterviewDate: yup.date().notRequired().nullable(),
  initialInterviewHeldBy: yup.string().notRequired().nullable(),
  nursingHomeInformation: yup.boolean().notRequired().nullable(),
  patientDecree: yup.boolean().notRequired().nullable(),
  pegTube: yup.boolean().notRequired().nullable(),
  integrationInterviewDate: yup.date().notRequired().nullable(),
  integrationInterviewHeldBy: yup.string().notRequired().nullable(),
  notPossibleLackOfConfidant: yup.boolean().notRequired().nullable(),
  notPossibleOtherReason: yup.mixed<ICheckboxWithText>().notRequired().nullable(),
  residentAttendant: yup.boolean().notRequired().nullable(),
  relativeAttendant: yup.boolean().notRequired().nullable(),
  supervisorAttendant: yup.boolean().notRequired().nullable(),
  otherConfidantAttendant: yup.boolean().notRequired().nullable(),
  attendees: yup.string().notRequired().nullable(),
  resultOfDiscussionAreDocumented: yup.boolean().notRequired().nullable(),
  referenceNurseOneId: yup.string().notRequired().nullable(),
  referenceNurseTwoId: yup.string().notRequired().nullable(),
  referenceNurseThreeId: yup.string().notRequired().nullable(),
  referenceSocialCareEmployeeId: yup.string().notRequired().nullable(),
});

export interface IResidentAdviceConsultation {
  initialInterviewDate?: Date;
  initialInterviewHeldBy?: string;
  nursingHomeInformation?: boolean;
  patientDecree?: boolean;
  pegTube?: boolean;
  integrationInterviewDate?: Date;
  integrationInterviewHeldBy?: string;
  notPossibleLackOfConfidant?: boolean;
  notPossibleOtherReason?: ICheckboxWithText;
  residentAttendant?: boolean;
  relativeAttendant?: boolean;
  supervisorAttendant?: boolean;
  otherConfidantAttendant?: boolean;
  attendees?: string;
  resultOfDiscussionAreDocumented?: boolean;
  referenceNurseOneId?: string;
  referenceNurseTwoId?: string;
  referenceNurseThreeId?: string;
  referenceSocialCareEmployeeId?: string;
}

export const CreateResidentAdviceConsultationSchema = yup
  .object({
    residentId: yup.string(),
  })
  .concat(ResidentAdviceConsultationSchema);

export interface ICreateResidentAdviceConsultation extends IResidentAdviceConsultation {
  residentId: string;
}

export const UpdateResidentAdviceConsultationSchema = yup
  .object({
    id: yup.string(),
  })
  .concat(ResidentAdviceConsultationSchema);

export interface IUpdateResidentAdviceConsultation {
  id: string;
  initialInterviewDate?: Date | null;
  initialInterviewHeldBy?: string | null;
  nursingHomeInformation?: boolean;
  patientDecree?: boolean;
  pegTube?: boolean;
  integrationInterviewDate?: Date | null;
  integrationInterviewHeldBy?: string | null;
  notPossibleLackOfConfidant?: boolean;
  notPossibleOtherReason?: ICheckboxWithText;
  residentAttendant?: boolean;
  relativeAttendant?: boolean;
  supervisorAttendant?: boolean;
  otherConfidantAttendant?: boolean;
  attendees?: string | null;
  resultOfDiscussionAreDocumented?: boolean;
  referenceNurseOneId?: string | null;
  referenceNurseTwoId?: string | null;
  referenceNurseThreeId?: string | null;
  referenceSocialCareEmployeeId?: string | null;
}
